"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var admin_student_documents_controller_1 = __importDefault(require("./admin-student-documents.controller"));
var admin_student_documents_html_1 = __importDefault(require("./admin-student-documents.html"));
var admin_student_view_document_module_1 = __importDefault(require("./view/admin-student-view-document.module"));
var assign_document_modal_module_1 = __importDefault(require("./components/assign-document-modal.module"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.students.view.documents", {
        url: "/documents",
        controller: admin_student_documents_controller_1.default,
        controllerAs: "vm",
        template: admin_student_documents_html_1.default,
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.staff,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.dashboard.students.view.documents", [
    admin_student_view_document_module_1.default.name,
    assign_document_modal_module_1.default.name,
])
    .config(config)
    .controller("AdminStudentDocumentsController", admin_student_documents_controller_1.default);
